export const sanitizeQueryParams = (query: Record<string, any>) => {
  const sanitized: Record<string, any> = {};
  if (!query) return sanitized;
  Object.keys(query).forEach((key) => {
    const value = query[key];
    if (value !== undefined && value !== null && value !== "") {
      sanitized[key] = value;
    }
  });
  return sanitized;
};
